import React, {useEffect, useState} from 'react';
import {View, Text} from 'react-native';
import {
    WorkoutContainerHeaderTwo,
    WorkoutContainerHeaderThree,
    WorkoutContainerText,
    WorkoutTextHeader
} from '../../../styles/common-styles.js';
import styled from 'styled-components/native';

function StreakDay(props) {

    const {date, completed = false, isStreak = false, displayFlame = false, index, checkForDuplicateDay} = props;
    const [duplicateDate, setDuplicateDate] = useState(0);
    const dateObj = new Date();

    useEffect(() => {
        const duplicate = checkForDuplicateDay(date, index);
        if(duplicate == true){
            setDuplicateDate(true);
            ////console.log(duplicate, date, index);
        }
    }, []);

    if (completed == false) {

        if (dateObj.getDate() == date && !duplicateDate) {
            return (
                <StreakDayParent>
                    <StreakDayContainerCurrentDay>
                        <WorkoutContainerTextStreak>{date}</WorkoutContainerTextStreak>
                    </StreakDayContainerCurrentDay>
                    {displayFlame == true && renderFlame()}
                </StreakDayParent>
            );
        }

        return (
            <StreakDayParent>
                <StreakDayContainer>
                    <WorkoutContainerTextStreak>{date}</WorkoutContainerTextStreak>
                </StreakDayContainer>
                {displayFlame == true && renderFlame()}
            </StreakDayParent>
        );
    }

    if (completed == true && isStreak == false) {
        return (
            <StreakDayParent>
                <StreakDayContainerCompleted>
                    <WorkoutContainerTextStreak>{date}</WorkoutContainerTextStreak>
                </StreakDayContainerCompleted>
                {displayFlame == true && renderFlame()}
            </StreakDayParent>
        );
    }

    if (completed == true && isStreak == true) {
        return (
            <StreakDayParent>
                <StreakDayContainerStreak>
                    <WorkoutContainerTextStreak>{date}</WorkoutContainerTextStreak>
                </StreakDayContainerStreak>
                {displayFlame == true && renderFlame()}
            </StreakDayParent>
        );
    }
}

const renderFlame = () => (
    <StreakDayFlame
        source={{
            uri: `https://dev.cerebrocoreusa.com/wp-content/uploads/2023/06/CerebroCore_Icons_streak-fire.png`
        }}
    />
);

export const StreakDayParent = styled.View`
`;

export const StreakDayContainer = styled.View`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 50px;
`

export const StreakDayContainerCurrentDay = styled.View`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 50px;
  border: 2px solid #c4579d;
`

export const StreakDayContainerCompleted = styled(StreakDayContainer)`
  background: #badbff;
`

export const StreakDayContainerStreak = styled(StreakDayContainer)`
  background: #fff;
`
export const StreakDayFlame = styled.Image`
  position: absolute;
  resizeMode: contain;
  width: 35px;
  height: 60px;
  bottom: -5px;
  right: 5px;
  left: 0;
`

export const WorkoutContainerTextStreak = styled(WorkoutContainerText)`

  font-size: 14px;

`


export default StreakDay;
